// import { ACCESS_LEVEL } from "../types/UserTypes"
import { ReactComponent as ClientsIcon } from "src/assets/all-clients-icon.svg";
import { ReactComponent as MembersIcon } from "src/assets/experts-icon.svg";
import { ReactComponent as CompaniesIcon } from "src/assets/institution-icon.svg";
import { ReactComponent as AllClientAppsIcon } from "src/assets/client-apps-icon.svg";
import { ReactComponent as AccountIcon } from "src/assets/settings-icon.svg";
import { ReactComponent as UploadIcon } from "src/assets/upload-icon.svg";
import { ReactComponent as LogoutIcon } from "src/assets/logout-icon.svg";
import { ReactComponent as ReferIcon } from "src/assets/refer-user-icon.svg";
import { ReactComponent as SupportIcon } from "src/assets/support-icon-white.svg";
import { ReactComponent as EventsIcon } from "src/assets/event-icon.svg";
import SideNavigationLink from "src/components/navigation/SideNav/SideNavigationLink";
import { userTypes } from "../types";

export const DASHBOARD_LINKS = {
  CLIENTS: (open: boolean) => (
    <SideNavigationLink
      url="/dashboard/consultant/clients"
      Icon={ClientsIcon}
      text="Clients"
      showText={open}
    />
  ),
  EVENTS: (open: boolean) => (
    <SideNavigationLink
      url="/dashboard/events"
      Icon={EventsIcon}
      text="Events"
      showText={open}
    />
  ),
  REQUESTS: (open: boolean) => (
    <SideNavigationLink
      url="/dashboard/neatt/action-items"
      Icon={UploadIcon}
      text="Requests"
      showText={open}
    />
  ),
  NOTES: (open: boolean) => (
    <SideNavigationLink
      url="/dashboard/neatt/profile-notes"
      Icon={UploadIcon}
      text="Notes"
      showText={open}
    />
  ),
  CLIENT_APPLICATIONS: (open: boolean) => (
    <SideNavigationLink
      url="/dashboard/clients/:id/applications"
      Icon={AllClientAppsIcon}
      text="Credit Forms"
      showText={open}
    />
  ),
  MEMBERS: (open: boolean) => (
    <SideNavigationLink
      url="/dashboard/members"
      Icon={MembersIcon}
      text="Members"
      showText={open}
    />
  ),
  COMPANIES: (open: boolean) => (
    <SideNavigationLink
      url="/dashboard/companies"
      Icon={CompaniesIcon}
      text="Companies"
      showText={open}
    />
  ),
  PARTNERS: (open: boolean) => (
    <SideNavigationLink
      url="/dashboard/referral-partners"
      Icon={ReferIcon}
      text="Referral Partners"
      showText={open}
    />
  ),
  CVA: (open: boolean) => (
    <SideNavigationLink
      url="/dashboard/consultants"
      Icon={UploadIcon}
      text="consultants"
      showText={open}
    />
  ),
  SUPPORT: (open: boolean) => (
    <SideNavigationLink
      url="/dashboard/support"
      Icon={SupportIcon}
      text="Support Tickets"
      showText={open}
    />
  ),
  ACCOUNT: (open: boolean) => (
    <SideNavigationLink
      url="/dashboard/account"
      Icon={AccountIcon}
      text="Account"
      showText={open}
    />
  ),
  LOGOUT: (open: boolean, logout: () => void) => (
    <SideNavigationLink
      url="/"
      Icon={LogoutIcon}
      text="Logout"
      showText={open}
      onClick={logout}
    />
  ),
};

export const extractLinks = (
  userType: userTypes.AccountTypes,
  open: boolean,
  logout: () => void
) => {
  if (userType === userTypes.AccountTypes.OWNER) {
    return [
      DASHBOARD_LINKS.CLIENTS(open),
      // DASHBOARD_LINKS.MEMBERS(open),
      // DASHBOARD_LINKS.COMPANIES(open),
      DASHBOARD_LINKS.PARTNERS(open),
      DASHBOARD_LINKS.CVA(open),
      // DASHBOARD_LINKS.CLIENT_APPLICATIONS(open),
      DASHBOARD_LINKS.ACCOUNT(open),
      // DASHBOARD_LINKS.SUPPORT(open),
      DASHBOARD_LINKS.LOGOUT(open, logout),
    ];
  } else if (
    userType === userTypes.AccountTypes.MANAGER ||
    userType === userTypes.AccountTypes.NEATT
  ) {
    return [
      DASHBOARD_LINKS.CLIENTS(open),
      // DASHBOARD_LINKS.CLIENT_APPLICATIONS(open),
      // DASHBOARD_LINKS.SUPPORT(open),
      DASHBOARD_LINKS.ACCOUNT(open),
      DASHBOARD_LINKS.LOGOUT(open, logout),
    ];
  } else if (userType === userTypes.AccountTypes.COMPANY) {
    return [
      DASHBOARD_LINKS.CLIENTS(open),
      DASHBOARD_LINKS.MEMBERS(open),
      DASHBOARD_LINKS.ACCOUNT(open),
      DASHBOARD_LINKS.LOGOUT(open, logout),
    ];
  }
  // else if(accessLevel === ACCESS_LEVEL.COMPANY_MEMBER) {
  //     return [
  //         DASHBOARD_LINKS.CLIENTS(open),
  //         DASHBOARD_LINKS.CLIENT_APPLICATIONS(open),
  //         DASHBOARD_LINKS.ACCOUNT(open),
  //         DASHBOARD_LINKS.LOGOUT(open, logout),
  //     ]
  else if (userType === userTypes.AccountTypes.REFERRAL) {
    return [
      DASHBOARD_LINKS.CLIENTS(open),
      DASHBOARD_LINKS.ACCOUNT(open),
      DASHBOARD_LINKS.LOGOUT(open, logout),
    ];
  } else {
    return [
      DASHBOARD_LINKS.REQUESTS(open),
      DASHBOARD_LINKS.NOTES(open),
      DASHBOARD_LINKS.ACCOUNT(open),
      DASHBOARD_LINKS.LOGOUT(open, logout),
    ];
  }
};
